export default "__VITE_ASSET__CDyUzmmM__"